module.exports = __webpack_public_path__ + "img/9-l.51969c9d.png";